import axios from 'axios'

export default {
    loadHeroBlocks() {
        return axios.get('/load-hero-blocks')
    },

    loadNews() {
        return axios.get('/api/news')
    },

    loadAchievements(group_id) {
        return axios.get('/load-achievements?group_id=' + group_id)
    },

    loadAchievementGroups() {
        return axios.get('/load-achievement-groups')
    }
}
